import React, { useContext, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";

//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import {
  Grid,
  Box,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import * as Yup from "yup";
import moment from "moment";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { CREATE_OPEN_INCOME_SHIFT } from "../../Schema/IncomeBill";
//date picker
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function OpenIncomeShift({
  open,
  handleClose,
  editData,
  // setRefetch,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);

  const [openIncomeShift] = useMutation(CREATE_OPEN_INCOME_SHIFT, {
    onCompleted: ({ openIncomeShift }) => {
      setLoading(false);
      if (openIncomeShift?.status === true) {
        setAlert(true, "success", openIncomeShift?.message);
        handleClose();
        // setRefetch();
      } else {
        setAlert(true, "error", openIncomeShift?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const CheckValidation = Yup.object().shape({
    shiftDate: Yup.date().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      shiftDate: moment(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      openIncomeShift({
        variables: {
          shiftDate: moment(values?.shiftDate).format("YYYY-MM-DD"),
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Open Shift</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Shift Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={values?.shiftDate}
                    inputFormat="dd-MM-yyyy"
                    onChange={(newValue) =>
                      setFieldValue("shiftDate", newValue)
                    }
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    Open Shift
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
